module.exports = __webpack_public_path__ + "e3da06cbcc4057d9384ffe950ccdd549.svg";